import { extrairErroEdgeFunction, invokeEdgeFunction } from './edgeFunctionInvoke'

function usuarioId() {
  try {
    if (localStorage.getItem('isAuthenticated') !== 'true') return ''
    const bruto = localStorage.getItem('usuario')
    return bruto ? JSON.parse(bruto).id || '' : ''
  } catch {
    return ''
  }
}

export async function consultarNotificacoes(acao, extra = {}) {
  const { data, error } = await invokeEdgeFunction('monitoramento-notificacoes', {
    acao,
    usuarioId: usuarioId(),
    ...extra
  })
  if (error || data?.success === false) {
    throw new Error(await extrairErroEdgeFunction(error, data))
  }
  return data
}
